import { createActionGroup, props } from '@ngrx/store';
import { User } from '../../services/model/user';

export const ProfileActions = createActionGroup({
  source: 'Profile',
  events: {
    'Profiles Loaded': props<{ profiles: User[] }>(),
  },
});